



































































































































import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import SelectEntity from "@/components/form/SelectEntity.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import { Course as ICourse } from "@/api/models/course";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import { Employee as IEmployee } from "@/api/models/employee";
import { ExpulsionOrderCreate as IExpulsionOrderCreate } from "@/api/models/expulsion-order-create";
import expulsionListeners, {
  ExpulsionOrdersListeners
} from "@/getinfo-api/expulsion-listeners";
import { getCurrentUserId, isRoot } from "@/plugins/roles";
import api from "@/getinfo-api";
import ListenersTable from "@/components/tables/ListenerTable.vue";
import { getCurrentCompanyId } from "@/plugins/roles";
import CField from "@/components/form/CField.vue";
import DocumentNumberInput from "@/components/form/DocumentNumberInput.vue";
import { nextSequence } from "@/utils/generate-helper";
import { CoursesListClass } from "@/classes/list/CoursesListClass";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { debounce } from "lodash";
import expulsionOrders, {
  ExpulsionOrdersListParam
} from "@/getinfo-api/expulsion-order";
import { ExpulsionOrderEdit as IExpulsionOrderEdit } from "@/api/models/expulsion-order-edit";
import { ExpulsionOrder as IExpulsionOrder } from "@/api/models/expulsion-order";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({
  components: {
    CustomButton,
    CBlock,
    CSingleSelect,
    DocumentNumberInput,
    CField,
    SelectEntity,
    CustomDatepicker,
    ListenersTable
  }
})
export default class expulsionOrderForm extends Vue {
  @Prop() propCourseId!: string;
  @Prop() propFinishedAt!: Date;
  @Prop() propEducationStartedAt!: Date;

  @Prop({ default: false }) isNewWindowOnSave?: boolean;
  number!: string;
  limit: number = 30;
  offset: number = 0;
  courseId!: string;
  course!: any;
  duplicateOrders: IExpulsionOrder[] = [];
  ownerId!: string;
  showSpinner: boolean = false;
  listenersCount: number = 0;
  listeners: Array<ICourseListener> = [];
  allListeners: Array<ICourseListener> = [];
  employees!: Array<IEmployee> | undefined;
  selectedListeners: Array<string> = [];
  signedAt!: Date;
  formedAt: Date = new Date();
  educationStartedAt!: Date;
  educationFinishedAt!: Date;
  coursesList: CoursesListClass = new CoursesListClass(
    { mode: "v2" },
    this.propCourseId ? this.propCourseId : this.courseId
  );

  data() {
    return {
      educationFinishedAt: undefined,
      educationStartedAt: undefined,
      signedAt: undefined,
      courseId: undefined,
      number: undefined,
      ownerId: undefined,
      course: undefined
    };
  }

  get amountOfDays() {
    if (this.course && this.course.hours) {
      return Math.ceil(this.course.hours / 8);
    } else {
      return 0;
    }
  }

  countStartFromFinished() {
    this.educationStartedAt = this.$store.getters[
      "companyUtils/GET_START_FROM_FINISH"
    ](this.educationFinishedAt, this.course.hours);
  }

  countFinishFromStart() {
    this.educationFinishedAt = this.$store.getters[
      "companyUtils/GET_FINISH_FROM_START"
    ](this.educationStartedAt, this.course.hours);
  }

  changeCourse(item: any) {
    this.course = item;
    this.getEmployeeIdCourseOwner(item.owner.id);
  }

  get screenWidth() {
    return window.innerWidth;
  }

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  getListeners(list: Array<ICourseListener>) {
    this.selectedListeners = list.map(el => el.id);
  }

  async useThisOrder(item: IExpulsionOrder) {
    this.showSpinner = true;
    let { data } = await api.ExpulsionOrderApi.get(item.id);
    if (data) {
      const edit: IExpulsionOrderEdit = {
        ownerId: data.ownerId,
        formedAt: data.formedAt,
        number: data.number,
        signedAt: data.signedAt,
        educationFinishedAt: data.educationFinishedAt,
        educationStartedAt: data.educationStartedAt,
        listeners: [
          ...this.selectedListeners,
          ...data.listeners.map(el => el.id)
        ],
        courseId: data.courseId,
        fileIds: data.files?.map((el: any) => el.id)
      };
      await api.ExpulsionOrderApi.edit(item.id, edit)
        .then(async res => {
          if (this.isNewWindowOnSave) {
            let routeData = this.$router.resolve({
              name: "expulsionOrder",
              params: { expulsionId: res.data.id }
            });
            await window.open(routeData.href, "_blank");
            this.$emit("saveOrder", res.data);
          } else {
            await this.$router.push({
              name: "expulsionOrder",
              params: { expulsionId: res.data.id }
            });
          }
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
      this.showSpinner = false;
    }
  }

  @Watch("number")
  @Watch("courseId")
  checkNumber = debounce(function() {
    //@ts-ignore
    let _this = this;
    if (_this.courseId && _this.number) {
      let params: ExpulsionOrdersListParam = {
        number: _this.number.length > 0 ? _this.number : undefined,
        courseIds: [_this.courseId],
        limit: 30
      };

      expulsionOrders(params).then(res => {
        _this.duplicateOrders = res.data.items;
      });
    }
  }, 400);

  getEmployeeIdCourseOwner(userId: string) {
    let params: EmployeeListParams = {
      id: this.selectedCompany,
      userIds: [userId]
    };
    employee(params).then((res: { data: IEmployeesList2 }) => {
      this.ownerId = res.data.employees[0].id;
    });
  }

  getExpulsionListeners() {
    this.allListeners = [];
    this.showSpinner = true;

    let params: ExpulsionOrdersListeners = {
      courseId: this.courseId,
      hasProtocol: false,
      limit: 1000
    };
    if (this.educationStartedAt) {
      params.createdAtMin = new Date(this.educationStartedAt);
      let educationStartedAtMax = new Date(this.educationStartedAt);
      educationStartedAtMax.setHours(23);
      educationStartedAtMax.setMinutes(59);
      params.createdAtMax = educationStartedAtMax;
    }

    expulsionListeners(params)
      .then((res: { data: any }) => {
        this.listenersCount = res.data.count;
        this.allListeners = res.data.listeners;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => (this.showSpinner = false));
  }

  @Watch("courseId")
  updateListeners() {
    this.allListeners = [];
    this.selectedListeners = [];
    this.listeners = [];
    this.getExpulsionListeners();
  }

  @Watch("selectedCompany")
  updateEmployees() {
    this.employees = undefined;
  }

  @Watch("educationStartedAt")
  checkStartData() {
    this.$store.dispatch("CLEAR_LISTENER_TABLE_STATE");
    this.selectedListeners = [];

    this.getExpulsionListeners();
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get userId() {
    return getCurrentUserId();
  }

  async saveExpulsion() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;
    if (this.$store.getters.GET_FORM_IS_INVALID) {
      return;
    }
    let params: IExpulsionOrderCreate = {
      number: this.number,
      formedAt: this.formedAt,
      signedAt: this.signedAt,
      ownerId: this.ownerId,
      educationStartedAt: this.educationStartedAt,
      educationFinishedAt: this.educationFinishedAt,
      listeners: this.selectedListeners,
      courseId: this.courseId
    };

    api.ExpulsionOrderApi.create(params)
      .then(async res => {
        await nextSequence();

        if (this.isNewWindowOnSave) {
          let routeData = this.$router.resolve({
            name: "expulsionOrder",
            params: { expulsionId: res.data.id }
          });
          await window.open(routeData.href, "_blank");
          this.$emit("saveOrder", res.data);
        } else {
          await this.$router.push({
            name: "expulsionOrder",
            params: { expulsionId: res.data.id }
          });
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  created() {
    this.educationStartedAt = new Date();
    this.educationStartedAt.setHours(0, 0, 0, 0);
    if (this.propCourseId) {
      this.courseId = this.propCourseId;
    }
    if (this.propEducationStartedAt) {
      this.educationStartedAt = new Date(this.propEducationStartedAt);
      this.educationStartedAt.setHours(0, 0, 0, 0);
    }
    if (this.propFinishedAt) {
      this.educationFinishedAt = new Date(this.propFinishedAt);
      this.formedAt = this.educationFinishedAt;
    }
  }
}
